import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import bywayXFirstChoiceLogoBlack from '~/assets/logos/byway-coop-stacked.svg';
const PartnerLoaderCoOpHolidays = () => {
  const $ = _c(4);
  const t = useTranslations("content");
  let t0;
  if ($[0] !== t) {
    t0 = t("partner_logo_coop_holidays");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="mx-auto max-w-[200px] md:max-w-[250px]"><Image src={bywayXFirstChoiceLogoBlack} alt={t0} height={32} className="w-full h-auto p-4 mx-auto md:max-w-56" /></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export { PartnerLoaderCoOpHolidays };